import { useEffect, useState } from 'react';
import axios from 'axios';
import './ManageMetalRates.css';

export default function ManageMetalRates() {
  const [rates, setRates] = useState([]);
  const [form, setForm] = useState({
    metal_type: '',
    price: '',
  });
  const [editId, setEditId] = useState(null);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 5;

  useEffect(() => {
    fetchRates();
  }, []);

  const fetchRates = async () => {
    const res = await axios.get('https://spinelleapi.emedha.in/home/page/api/admin/metal-price');
    setRates(res.data);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const submitRate = async () => {
    if (!form.metal_type || !form.price) {
      alert('Please fill all fields');
      return;
    }

    if (editId) {
      await axios.put(`https://spinelleapi.emedha.in/home/page/api/admin/metal-price/${editId}`, form);
    } else {
      await axios.post('https://spinelleapi.emedha.in/home/page/api/admin/metal-price', form);
      alert('Metal price saved successfully!');
    }

    resetForm();
    fetchRates();
  };

  const resetForm = () => {
    setForm({ metal_type: '', price: '' });
    setEditId(null);
  };

  const editRate = (rate) => {
    setEditId(rate.id);
    setForm({
      metal_type: rate.metal_type,
      price: rate.price,
    });
  };

  const deleteRate = async (id) => {
    if (window.confirm('Are you sure?')) {
      await axios.delete(`https://spinelleapi.emedha.in/home/page/api/admin/metal-price/${id}`);
      fetchRates();
    }
  };

  // Pagination logic
  const start = (currentPage - 1) * perPage;
  const current = rates.slice(start, start + perPage);
  const pages = Math.ceil(rates.length / perPage);

  return (
    <div className="manage-container">
      <div className="form-container">
        <h2>Gold & Silver Rates</h2>

        <div className="form-group1">
          <select
            name="metal_type"
            value={form.metal_type}
            onChange={handleChange}
          >
            <option value="">Select Metal</option>
            <option value="gold">Gold</option>
            <option value="silver">Silver</option>
          </select>

          <input
            type="number"
            name="price"
            placeholder="Price"
            value={form.price}
            onChange={handleChange}
          />

          <button onClick={submitRate}>
            {editId ? 'Update Price' : 'Save Price'}
          </button>

          {editId && (
            <button className="cancel-btn" onClick={resetForm}>
              Cancel
            </button>
          )}
        </div>
      </div>

      {/* Table */}
      <table className="category-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Metal</th>
            <th>Price</th>
            <th>Updated</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {current.map((r, i) => (
            <tr key={r.id}>
              <td>{start + i + 1}</td>
              <td style={{ textTransform: 'capitalize' }}>{r.metal_type}</td>
              <td>{r.price}</td>
            <td>
  {new Date(r.updated_at).toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    dateStyle: 'medium',
    timeStyle: 'short',
  })}
</td>

              <td>
                <button className="edit-btn" onClick={() => editRate(r)}>
                  Edit
                </button>
                <button
                  className="delete-btn"
                  onClick={() => deleteRate(r.id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}

          {current.length === 0 && (
            <tr>
              <td colSpan="5" style={{ textAlign: 'center' }}>
                No records found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="pagination">
        {[...Array(pages)].map((_, i) => (
          <button
            key={i}
            className={currentPage === i + 1 ? 'active' : ''}
            onClick={() => setCurrentPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}
      </div>
    </div>
  );
}
